import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/cartReducer";
import "./Card.scss";
import { toast } from "react-toastify";
import axios from "axios";

const OffcerCard = ({ item }) => {
  const [countdown, setCountdown] = useState("");
  const [isSaleActive, setIsSaleActive] = useState(true);
  const dispatch = useDispatch();

  const cartItem = useSelector((state) =>
    state.cart.products.find((i) => i.id === item._id)
  );
  const quantity = cartItem?.quantity || 0;

  const handleAddToCart = () => {
    if (!isSaleActive || item.outofstock) {
      toast.error("This product is unavailable");
      return;
    }
    // Determine max allowed quantity
    const maxAllowed =
      item.flashSale === "yes" && item.flashMaxPcs > 0 ? item.flashMaxPcs : 0; // 0 means no limit
    // Check against maxAllowed if it is > 0
    if (maxAllowed > 0 && quantity + 1 > maxAllowed) {
      toast.warn(
        `Max limit reached (${item.flashMaxPcs} pcs for flash sale product)`
      );
      return;
    }

    dispatch(
      addToCart({
        id: item._id,
        name: item.name,
        desc: item.desc,
        weight: item.weight,
        price: item.flashSale === "yes" ? item.flashPrice : item.price,
        stock: item.stock,
        img: item.proPhotos[0],
        quantity: 1,
        originalPrice: item.price,
        flashPrice: item.flashPrice,
        flashSale: item.flashSale,
        flashEndDate: item.toFlashSaleDate,
        flashEndTime: item.toFlashSaleTime,
        flashMaxPcs: item.flashMaxPcs,
      })
    );

    toast.success("Added to cart!");
  };

  const createDateTime = (date, time) => {
    return new Date(`${date}T${time}:00`);
  };

  const getCountdown = () => {
    const now = new Date();
    const start = createDateTime(
      item.fromFlashSaleDate,
      item.fromFlashSaleTime
    );
    const end = createDateTime(item.toFlashSaleDate, item.toFlashSaleTime);

    if (now < start) {
      setIsSaleActive(false);
      return "Sale hasn’t started yet!";
    } else if (now > end) {
      setIsSaleActive(false);
      return "Sale ended!";
    }

    // Sale is active
    setIsSaleActive(true);

    const diff = end - now;
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    return `${days}d ${hours}h ${minutes}m ${seconds}s`;
  };

  useEffect(() => {
    setCountdown(getCountdown());
    const interval = setInterval(() => {
      setCountdown(getCountdown());
    }, 1000);

    return () => clearInterval(interval);
  }, [item]);

  useEffect(() => {
    const changeType = async () => {
      const data = {
        type: "normal",
        flashPrice: "",
        fromFlashSaleDate: "",
        fromFlashSaleTime: "",
        toFlashSaleDate: "",
        toFlashSaleTime: "",
        flashMaxPcs: "",
        maxPcs: "",
        flashSale: "",
      };
      try {
        await axios.put(`/update-type/${item._id}`, data);
      } catch (error) {
        console.error("Type update failed:", error);
      }
    };

    if (item.outofstock || !isSaleActive) {
      changeType();
    }
  }, [item.outofstock, isSaleActive, item._id]);

  return (
    <div className="card">
      <div className="image-wrapper">
        {item.discount && (
          <>
            {item.flashSale === "yes" ? (
              <span className="badge discount">
                {(
                  ((item.oldPrice - item.flashPrice) / item.oldPrice) *
                  100
                ).toFixed(0)}
                %
              </span>
            ) : (
              <span className="badge discount">{item.discount}%</span>
            )}
          </>
        )}
        {(item.outofstock || !isSaleActive) && (
          <span className="badge out">Unavailable</span>
        )}

        <img
          src={`${process.env.REACT_APP_DOC_VIEW_LINK}/${item.proPhotos[0]}`}
          alt={item.name}
          className="mainImg"
        />
        <img
          src={`${process.env.REACT_APP_DOC_VIEW_LINK}/${item.proPhotos[1]}`}
          alt={item.name}
          className="hoverImg"
        />
      </div>
      {item.flashSale === "yes" && (
        <div className="flsh_price">
          <div className="fl_in">
            <span>Flash Sale Price </span>
          </div>
          <div className="fl_prc">
            {item.flashSale === "yes" && (
              <span className="old-price">
                <em>AED</em> {item.flashPrice}
              </span>
            )}
          </div>
        </div>
      )}

      <div className="card-content">
        <h3 className="title">{item.name}</h3>
        <p className="weight">Weight: {item.weight}</p>

        <div className="bt_wrp">
          <div className="price-section">
            {item.oldPrice && (
              <span className="old-price">
                <em>AED </em>
                {item.oldPrice}
              </span>
            )}
            <span className="price">
              {item.flashSale === "yes" ? (
                <span className="old-price">
                  <em>AED</em> {item.price}
                </span>
              ) : (
                <>
                  <em>AED</em> {item.price}
                </>
              )}
            </span>
          </div>

          <button
            className="add-btn"
            onClick={handleAddToCart}
            disabled={item.outofstock || !isSaleActive}
          >
            {item.outofstock || !isSaleActive ? "Unavailable" : "Add to Cart"}
          </button>
        </div>

        {/* {item.outofstock || !isSaleActive ? (
          <Link className="learn-more">Learn More</Link>
        ) : (
          <Link to={`/product/${item.slug}`} className="learn-more">
            Learn More
          </Link>
        )} */}
        {item.flashSale === "yes" && (
          <div className="count_down">
            <div className="coun_in">
              <div className="con_prs">
                <span>Save AED {item.oldPrice - item.flashPrice} extra </span>
              </div>
              <div className="con_time">
                <span>{countdown}</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OffcerCard;
